import React from 'react';
import { Translate } from 'react-jhipster';
import { NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BrandIcon = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className="brand-icon">
    <img src="content/images/navbar-logo.png" alt="Logo" />
  </div>
);

export const Brand = () => (
  <NavbarBrand tag={Link} to="/" className="brand-logo">
    <BrandIcon />
    <span className="brand-title"></span>
  </NavbarBrand>
);

const isHomePage = () => {
  if (typeof window !== 'undefined') {
    return window.location.pathname === '/';
  }
  return false;
};

export const Home = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className={`d-flex align-items-center home-link ${isHomePage() ? 'active' : ''}`}>
      <FontAwesomeIcon icon="home" className="me-2" />
      <span>
        <Translate contentKey="global.menu.home">Home</Translate>
      </span>
    </NavLink>
  </NavItem>
);
